export { default as Variant1 } from './Variant1'

export { default as Variant2 } from './Variant2'

export { default as Variant3 } from './Variant3'

export { contentMock } from './FormLayout.mock'
